import { render } from "./Contact.vue?vue&type=template&id=1a05e6d5&scoped=true"
import script from "./Contact.js?vue&type=script&lang=js"
export * from "./Contact.js?vue&type=script&lang=js"

import "./Contact.scss?vue&type=style&index=0&id=1a05e6d5&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a05e6d5"]])

export default __exports__